var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  width: 100%;\n  background-color: ', ';\n  box-shadow: ', ';\n  margin-bottom: 20px;\n  \n  @media (min-width: 1199px) {\n    flex-basis: 66%;\n  }\n  @media (max-width: 768px) {\n    height: 100%;\n  }\n'], ['\n  display: flex;\n  width: 100%;\n  background-color: ', ';\n  box-shadow: ', ';\n  margin-bottom: 20px;\n  \n  @media (min-width: 1199px) {\n    flex-basis: 66%;\n  }\n  @media (max-width: 768px) {\n    height: 100%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: ', ';\n  justify-content: space-between;\n  padding: 30px 0;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n\n  @media(min-width: 768px){\n    & div.resource-card + div {\n      ', '\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  justify-content: space-between;\n  padding: 30px 0;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n\n  @media(min-width: 768px){\n    & div.resource-card + div {\n      ', '\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { Fragment } from 'react';
import styled from 'styled-components';
import ResourceCard from './ResourceCard';
import { white, darkgrey } from '../../assets/colors';
import Theme from '../../Theme';

export var ResourceFrame = styled.div(_templateObject, function (props) {
  return props.color;
}, function (_ref) {
  var plain = _ref.plain;
  return plain ? 'none' : '0 5px 10px 0 ' + Theme.colors.primaryShadow;
});

export var FlexCard = styled.div(_templateObject2, function (_ref2) {
  var vertical = _ref2.vertical;
  return vertical ? 'column' : 'row';
}, function (_ref3) {
  var separator = _ref3.separator;
  return separator && 'border-left: 2px solid ' + darkgrey + ';';
});

export default (function (_ref4) {
  var vertical = _ref4.vertical,
      separator = _ref4.separator,
      resources = _ref4.resources,
      plain = _ref4.plain;
  return React.createElement(
    ResourceFrame,
    { color: white, plain: plain },
    React.createElement(
      FlexCard,
      { separator: separator, vertical: vertical },
      resources.map(function (resource) {
        return React.createElement(
          Fragment,
          { key: resource.id },
          React.createElement(ResourceCard, { resource: resource, vertical: vertical })
        );
      })
    )
  );
});